import { create } from 'zustand';

interface alertModalDataState {
  data: { active: string; content: any; data: any; link?: string };
  set: (data: { active: string; content: any; data: any; link?: string }) => void;
}
interface alertModalViewState {
  data: { active: string; data: any };
  set: (data: { active: string; data: any }) => void;
}
interface errorModalViewState {
  data: { active: string; data: any };
  set: (data: { active: string; data: any }) => void;
}
interface loadingModalViewState {
  result: { active: string; data: any };
  set: (data: { active: string; data: any }) => void;
}
interface confirmModalViewState {
  data: { active: string; content: any; cancleEvt: any; confirmEvt: any };
  set: (data: { active: string; content: any; cancleEvt: any; confirmEvt: any }) => void;
  close: (data: { active: string; content: any }) => void;
}
interface contentModalViewState {
  data: { active: string; content: any };
  set: (data: { active: string; content: any }) => void;
  close: (data: { active: string; content: any }) => void;
}
interface hintModalViewState {
  data: { active: string; content: any };
  set: (data: { active: string; content: any }) => void;
  close: (data: { active: string; content: any }) => void;
}

/**
  Alert Modal 상태관리
**/
export const alertModalDataStore = create<alertModalDataState>(set => ({
  data: { active: '', content: null, data: null, link: '' },
  set: (data: any) => set(state => ({ ...state, data: data })),
}));

/**
  Alert View Modal 상태관리
**/
export const alertModalViewStore = create<alertModalViewState>(set => ({
  data: { active: '', data: {} },
  set: (data: any) => set(state => ({ ...state, data: data })),
}));

/**
  Alert View Modal 상태관리
**/
export const rightBannerModalViewStore = create<alertModalViewState>(set => ({
  data: { active: '_active', data: {} },
  set: (data: any) => set(state => ({ ...state, data: data })),
}));

/**
  Error Modal 상태관리
**/
export const errorModalViewStore = create<errorModalViewState>(set => ({
  data: { active: '', data: {} },
  set: (data: any) => set(state => ({ ...state, data: data })),
}));

/**
  Loading Modal 상태관리
**/
export const loadingModalViewStore = create<loadingModalViewState>(set => ({
  result: { active: '', data: {} },
  set: (data: any) => set(state => ({ ...state, result: data })),
}));

/**
  Confirm Modal 상태관리
**/
export const confirmModalViewStore = create<confirmModalViewState>(set => ({
  data: { active: '', content: null, cancleEvt: null, confirmEvt: null },
  set: (data: any) => set(state => ({ ...state, data: data })),
  close: (data: any) =>
    set(state => ({
      ...state,
      data: { ...state.data, content: data.content, active: data.active },
    })),
}));

/**
  Content Modal 상태관리
**/
export const contentModalViewStore = create<contentModalViewState>(set => ({
  data: { active: '', content: null },
  set: (data: any) => set(state => ({ ...state, data: data })),
  close: (data: any) =>
    set(state => ({
      ...state,
      data: { ...state.data, content: data.content, active: data.active },
    })),
}));

/**
  Content Modal 상태관리
**/
export const contentModalDep2ViewStore = create<contentModalViewState>(set => ({
  data: { active: '', content: null },
  set: (data: any) => set(state => ({ ...state, data: data })),
  close: (data: any) =>
    set(state => ({
      ...state,
      data: { ...state.data, content: data.content, active: data.active },
    })),
}));

/**
  Hint Modal 상태관리
**/
export const hintModalViewStore = create<hintModalViewState>(set => ({
  data: { active: '', content: null },
  set: (data: any) => set(state => ({ ...state, data: data })),
  close: (data: any) =>
    set(state => ({
      ...state,
      data: { ...state.data, content: data.content, active: data.active },
    })),
}));
